import new1 from "../assets/img/new1.png";
import new2 from "../assets/img/new2.png";
import new3 from "../assets/img/new3.png";
import new4 from "../assets/img/new4.png";
import new5 from "../assets/img/new5.png";
import new6 from "../assets/img/new6.png";
import t1 from "../assets/news/t1.jpg";
import w1 from "../assets/news/ww1.jpg";
import research from "../assets/news/research.png";
import e3 from "../assets/news/f3.jpg";
import e7 from "../assets/news/f7.jpg";
import s4 from "../assets/news/s4.jpg";

const tidings = [
  {
    id: 0,
    date: "25 Nov",
    image: new1,
    bigImge: w1,
    author: "By Rachi Card",
    title: "The Benefits of Vitamin D & How to Get It",
    text: "Simply dummy text of the printing and typesetting industry. Lorem Ipsum",
    bigText:
      "Uniquely matrix economically sound value through cooperative technology. Competently parallel task fully researched data and enterprise process improvements. Collaboratively expedite quality manufactured products via client-focused results quickly communicate enabled technology and turnkey leadership skills. Uniquely enable accurate supply chains rather than friction technology.",
  },
  {
    id: 1,
    date: "22 Nov",
    image: new2,
    bigImge: t1,
    author: "By Rachi Card",
    title: "Our Favorite Summertime Tomato",
    text: "Simply dummy text of the printing and typesetting industry. Lorem Ipsum",
    bigText:
      "Uniquely matrix economically sound value through cooperative technology. Competently parallel task fully researched data and enterprise process improvements. Collaboratively expedite quality manufactured products via client-focused results quickly communicate enabled technology and turnkey leadership skills. Uniquely enable accurate supply chains rather than friction technology.",
  },
  {
    id: 2,
    date: "14 Jul",
    image: new3,
    bigImge: e3,
    author: "By Rachi Card",
    title: "Benefits of Vitamin C & How to Get It",
    text: "Simply dummy text of the printing and typesetting industry. Lorem Ipsum",
    bigText:
      "Uniquely matrix economically sound value through cooperative technology. Competently parallel task fully researched data and enterprise process improvements. Collaboratively expedite quality manufactured products via client-focused results quickly communicate enabled technology and turnkey leadership skills. Uniquely enable accurate supply chains rather than friction technology.",
  },
  {
    id: 3,
    date: "29 Jun",
    image: new4,
    bigImge: research,
    author: "By Rachi Card",
    title: "Research More Organic Foods",
    text: "Simply dummy text of the printing and typesetting industry. Lorem Ipsum",
    bigText:
      "Uniquely matrix economically sound value through cooperative technology. Competently parallel task fully researched data and enterprise process improvements. Collaboratively expedite quality manufactured products via client-focused results quickly communicate enabled technology and turnkey leadership skills. Uniquely enable accurate supply chains rather than friction technology.",
  },
  {
    id: 4,
    date: "12 Sep",
    image: new5,
    bigImge: e7,
    author: "By Rachi Card",
    title: "Everyday Fresh Fruites",
    text: "Simply dummy text of the printing and typesetting industry. Lorem Ipsum",
    bigText:
      "Uniquely matrix economically sound value through cooperative technology. Competently parallel task fully researched data and enterprise process improvements. Collaboratively expedite quality manufactured products via client-focused results quickly communicate enabled technology and turnkey leadership skills. Uniquely enable accurate supply chains rather than friction technology.",
  },
  {
    id: 5,
    date: "02 Dec",
    image: new6,
    bigImge: s4,
    author: "By Rachi Card",
    title: "Everyday Fresh Fruites",
    text: "Simply dummy text of the printing and typesetting industry. Lorem Ipsum",
    bigText:
      "Uniquely matrix economically sound value through cooperative technology. Competently parallel task fully researched data and enterprise process improvements. Collaboratively expedite quality manufactured products via client-focused results quickly communicate enabled technology and turnkey leadership skills. Uniquely enable accurate supply chains rather than friction technology.",
  },
];

export { tidings };
